module.exports = __webpack_public_path__ + "img/pos7_banner.ac93cadb.jpg";